import { Outlet } from 'react-router-dom';
import { Flex, Box } from '@radix-ui/themes';

import Sidebar from '../components/Sidebar';
import CommandPalette from '../components/CommandPalette';
import './Layout.css';

const RootLayout = () => (
  <Flex className="root-layout">
    <Sidebar />
    <Box className="main-content">
      <Outlet />
    </Box>
    <CommandPalette />
  </Flex>
);

export default RootLayout;
